<template>
  <section class="ranking">
    <div class="rank-header">
      <div class="col1">省份</div>
      <div class="col2">销售额</div>
      <div class="col3">全国占比</div>
    </div>
    <div class="rank-body">
      <div v-for="(item, index) in regionSalesVoList" :key="index">
        <div class="col1">{{ item.provinceName }}</div>
        <div class="col2">{{ item.salesAmount }}</div>
        <div class="col3">{{ item.proportion }}</div>
      </div>
<!--      <div>-->
<!--        <div class="col1">江苏省</div>-->
<!--        <div class="col2">23330</div>-->
<!--        <div class="col3">10%</div>-->
<!--      </div>-->
<!--      <div>-->
<!--        <div class="col1">江苏省</div>-->
<!--        <div class="col2">23330</div>-->
<!--        <div class="col3">10%</div>-->
<!--      </div>-->
<!--      <div>-->
<!--        <div class="col1">江苏省</div>-->
<!--        <div class="col2">23330</div>-->
<!--        <div class="col3">10%</div>-->
<!--      </div>-->
<!--      <div>-->
<!--        <div class="col1">江苏省</div>-->
<!--        <div class="col2">23330</div>-->
<!--        <div class="col3">10%</div>-->
<!--      </div>-->
<!--      <div>-->
<!--        <div class="col1">江苏省</div>-->
<!--        <div class="col2">23330</div>-->
<!--        <div class="col3">10%</div>-->
<!--      </div>-->
    </div>
  </section>
</template>

<script>
export default {
  name: 'ranking',
  props: {
    regionSalesVoList: Array
  },
  data() {
    return {
      rankingList: []
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.ranking {
  background: url("../assets/images/rank-block.svg") no-repeat center center / 100%;
  width: 275px;
  height: 135px;
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 10px;
  font-weight: normal;
  line-height: normal;
  padding: 16px 20px 12px 26px;
  position: absolute;
  left: 5%;
  bottom: 0;
  .rank-header{
    display: flex;
    line-height:  16px;
    padding-top: 6px
  }
  .rank-body{
    flex: 1;
    padding-top: 6px;
    overflow: auto;
    >div{
      display: flex;
      line-height: 20px;
      &:nth-child(odd) {
        background-color: rgba(0, 224, 247, 0.39);
      }
    }
  }
  .col1, .col2, .col3{
     flex: 1;
    padding: 0 4px;
   }
}
@media (max-width: 768px) {
  .ranking {
    position:static;
  }
}
</style>
